/**
 * View component for /user/forgot-password
 *
 * allows user to submit a password reset request to their email on record.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';


// import actions
import * as userActions from '../userActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import form components
import { EmailInput } from '../../../global/components/forms';

// import user components
import UserLoginLayout from '../components/UserLoginLayout.js.jsx';

class RequestPasswordResetLink extends Base {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ''
      , isErrorModalOpen: false
      , isSuccessModalOpen: false
      , username: ""
    };
    this._bind(
      '_closeSuccessModal'
      , '_handleFormChange'
      , '_handleFormSubmit'
      , '_openSuccessModal'
      , '_toggleErrorModal'
    );
  }

  _handleFormChange(e) {
    var nextState = this.state;
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  }

  _handleFormSubmit(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch(userActions.sendForgotPassword(this.state.username)).then((action) => {
      if(action.success) {
        this._openSuccessModal();
      } else {
        this.setState({errorMessage: action.error});
        this._toggleErrorModal();
      }
    })
  }

  _openSuccessModal() {
    this.setState({isSuccessModalOpen: true});
  }

  _closeSuccessModal() {
    this.setState({isSuccessModalOpen: false});
    const { history } = this.props;
    history.push('/');
  }

  _toggleErrorModal() {
    this.setState({isErrorModalOpen: !this.state.isErrorModalOpen});
  }

  render() {
    const { user } = this.props;
    return  (
      <UserLoginLayout>
        <Helmet
          title={"Request Password | Pro-ficiency"}
        />
        <div className="yt-container user-login-container">
          <div className="yt-row center-horiz space-around">
            <div className="yt-col full s_40 m_33 l_30">
              <form name="passwordResetForm" className="user-login-form" onSubmit={this._handleFormSubmit}>
                <img className="-partner-logo" src="/img/logo-pd0.png" />
                <h1 className="-form-header"> Reset Password</h1>
                <p className="-form-sub-header">Enter your email and we'll send you a link to reset your password.</p>
                <hr/>
                <EmailInput
                  name="username"
                  label="Email"
                  value={this.state.username}
                  change={this._handleFormChange}
                  required={true}
                />
                <div className="yt-row space-between">
                  <div className="yt-col center">
                    <Link className="-forgot" to="/user/login"><em> Back To Login</em> </Link>
                  </div>
                  <button className="yt-btn primary" type="submit" disabled={user.isFetching}>
                    {user.isFetching ?
                      <span>Sending...</span>
                      :
                      <span>Send Reset Link</span>
                    }
                  </button>
                </div>
              </form>
            </div>
            <div className="yt-col full s_50 m_60 l_60 -hero-container">
              <div className="-hero"></div>
            </div>
          </div>
          <AlertModal
            alertMessage="If you have an account with that email address, you should receive an email with password reset instructions shortly."
            alertTitle="Success"
            closeAction={this._closeSuccessModal}
            confirmAction={this._closeSuccessModal}
            confirmText="Got it"
            isOpen={this.state.isSuccessModalOpen}
            type="info"
          />
          <AlertModal
            alertMessage={
              <div>
                <strong>
                  {this.state.errorMessage}
                </strong>
                <br/>
                <div>You may need to contact <a href="mailto:prosupport@simulations-plus.com">prosupport@simulations-plus.com</a>.</div>
              </div>
            }
            alertTitle="Error"
            closeAction={this._toggleErrorModal}
            confirmAction={this._toggleErrorModal}
            confirmText="Try again"
            isOpen={this.state.isErrorModalOpen}
            type="danger"
          />
        </div>
      </UserLoginLayout>
    )
  }
}

RequestPasswordResetLink.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return { user: store.user.loggedIn }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(RequestPasswordResetLink)
);



// WEBPACK FOOTER //
// modules/user/views/RequestPasswordResetLink.js.jsx